import React from 'react';
import IconTruck from 'src/presentations/components/organisms/actionDetails/tabsDetails/transportSummary/icons/Truck';
import IconShip from 'src/presentations/components/organisms/actionDetails/tabsDetails/transportSummary/icons/Ship';
import IconAeroplane from 'src/presentations/components/organisms/actionDetails/tabsDetails/transportSummary/icons/Aeroplane';
import IconCourier from 'src/presentations/components/organisms/actionDetails/tabsDetails/transportSummary/icons/Courier';
import IconCt from 'src/presentations/components/organisms/actionDetails/tabsDetails/transportSummary/icons/Ct';

const iconProps = {
  color: '#BFBFBF',
  size: 24,
};

export function getRateCardModalityIcon(modality: string): React.ReactNode {
  switch (modality) {
    case 'ROAD':
    case 'RAIL':
      return <IconTruck {...iconProps} />;
    case 'SEA':
      return <IconShip {...iconProps} />;
    case 'AIR':
      return <IconAeroplane {...iconProps} />;
    case 'COURIER':
      return <IconCourier {...iconProps} />;
    case 'CT':
      return <IconCt {...iconProps} />;
    default:
      return null;
  }
}

export function getRateCardModalityTitle(modality: string): string {
  switch (modality) {
    case 'CT':
      return 'CONTROL TOWER';
    case 'COURIER':
      return 'COURIER';
    default:
      return modality;
  }
}
